import apiService from '../../../services/api-client';
import { MetricConfiguration } from '../interfaces/get-metrics-config';
import { MetricConfigurationCreate } from '../interfaces/post-metrics-config';

export const metricsApiService = {
  async getMetricsConfig(id: string) {
    const { data } = await apiService().get<MetricConfiguration[]>(
      `/metric-configurations?company_id=${id}`
    );
    return data;
  },

  async postMetricsConfig(id: string, body: MetricConfigurationCreate) {
    const { data } = await apiService().post<MetricConfiguration>(`/metric-configurations?company_id=${id}`, body);
    return data;
  },

  async putMetricsConfig(id:string, idConfig: string, body: MetricConfigurationCreate) {
    const { data } = await apiService().put<MetricConfiguration>(`/metric-configurations/${idConfig}?company_id=${id}`);
    return data;
  },

  async deleteMetricsConfig(id:string, idConfig: string) {
    const { data } = await apiService().delete<MetricConfiguration>(`/metric-configurations/${idConfig}?company_id=${id}`);
    return data;
  },
};